// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.

console.log(
	'%c This site was designed & developed by https://www.sleeplessmedia.com',
	'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'
);

// Cookies functions
function setCookie(cookieName, cookieValue) {
	var today = new Date();
	var expire = new Date();
	expire.setTime(today.getTime() + 3600000 * 24 * 7);
	document.cookie =
		cookieName +
		'=' +
		encodeURI(cookieValue) +
		';expires=' +
		expire.toGMTString();
}

function getCookie(cname) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function deleteCookie(name) {
	document.cookie = name + '=; Max-Age=-99999999; path=/';
}

function getDatasetMatchingVariant(variantId, el, key) {
	var dataStr = el.dataset[key];
	var arr = dataStr && dataStr.split(',');
	if (!arr) return void 0;
	var item = arr.find(function (delItem) {
		var id = delItem.split('-')[0];
		return id === variantId.toString();
	});
	var value = item && item.split('-')[1];
	return value;
}
function updateAvailabilityText(variantId) {
	var el = document.querySelector('div[data-estimated-delivery-dates]');
	var span = el && el.querySelector('span');
	if (!el || !span) return;
	var date = getDatasetMatchingVariant(
		variantId,
		el,
		'estimatedDeliveryDates'
	);
	var text = date ? '* Expected Availability Date: '.concat(date) : '';
	span.textContent = text;
}
